import { useApp } from '../store/app';
import { skipBack, togglePlay } from '../player/engine';
import { effectiveChapters } from '../lib/bookMath';
import { activeChapterIndex } from '../player/engine';
import { Cover, NmIconButton } from './nm';
import { PauseIcon, PlayIcon, SkipBackIcon } from './icons';

/** Docked player that survives navigation, so leaving the player screen never
  * means losing your place in the controls. */
export function MiniPlayer() {
   const bookId = useApp((s) => s.currentBookId);
   const book = useApp((s) => s.books.find((b) => b.id === s.currentBookId) ?? null);
   const route = useApp((s) => s.route);
   const navigate = useApp((s) => s.navigate);
   const playing = useApp((s) => s.playing);
   const positionSec = useApp((s) => s.positionSec);
   const trackDurationSec = useApp((s) => s.trackDurationSec);
   const trackIndex = useApp((s) => s.trackIndex);
   const rawChapters = useApp((s) => s.chapters);

   // Hidden on the player screen itself — the full controls are already there.
   if (!book || !bookId || route.name === 'player') return null;

   const chapters = effectiveChapters(book, rawChapters);
   const idx = activeChapterIndex(chapters, trackIndex, positionSec);
   const chapterTitle = idx >= 0 ? chapters[idx]?.title : undefined;
   const ratio = trackDurationSec > 0 ? positionSec / trackDurationSec : 0;

   return (
      <div className="mini nm-raised">
        <div className="mini__progress" style={{ transform: `scaleX(${Math.min(1, ratio)})` }} />

        <button
          type="button"
          className="mini__open"
          onClick={() => navigate({ name: 'player', bookId })}
        >
          <span className="nm-inset nm-xs mini__frame">
             <Cover title={book.title} url={book.coverUrl} />
          </span>
          <span className="mini__meta">
             <span className="mini__title">{book.title}</span>
             <span className="mini__chapter">{chapterTitle ?? book.author ?? ''}</span>
          </span>
        </button>

        <div className="mini__controls">
          <NmIconButton label="Back 15 seconds" size={40} onClick={() => skipBack()}>
             <SkipBackIcon size={19} seconds={15} />
          </NmIconButton>
          <NmIconButton
             label={playing ? 'Pause' : 'Play'}
             size={46}
             onClick={() => void togglePlay()}
          >
             {playing ?
               <PauseIcon size={20} />
             : <PlayIcon size={20} />}
          </NmIconButton>
        </div>
      </div>
   );
}
